/**
 * movie.js
 */

// Youtube API
//////////////////////////////////
// Google API Key(for youtube api)
var APIKEY="AIzaSyD2s_mdPwjNMkVS6G3mocswWlmaJQGbjvI";
// var PLAYLIST_ID="PLO-lVJPgHSfOxpNeM99jBiCpYaZcyH4fL";//足跡姫
var PLAYLIST_ID="PLO-lVJPgHSfOQvHXgqf1DadKmqCRyzdcc";//桜


window.onJSClientLoad = function() {
	gapi.client.setApiKey(APIKEY);
	gapi.client.load('youtube', 'v3', function(){
		$.getYouTubeResults({
			"maxResults": 20,
		});
	});
};


$(function(){

  function addUpdateIconNav() {
    $('#mainnav .menu .movie').next('.update').remove();
    $('#mainnav .menu .movie').after('<span class="update">Updates</span>');
  }

  // セッションストレージ確認
  var updateMovie = window.sessionStorage.getItem('updateMovie');
  if ( updateMovie == 'true' || updateMovie == true ) {
    addUpdateIconNav();
    if (!$('body').hasClass('checkmovie')) {
      return false; //TOPとMOVIE以外は、strageにあれば処理終了
    }
  }

$.getYouTubeResults=function(options) {

  var opt=$.extend({
    "type":"video",
    "maxResults": 20,
    "playlistId":PLAYLIST_ID
  },options);

  var pageToken="";
  var allcnt=0, j=0, totalResults=0, resultsPerPage=0, total=0;

  var requestOptions = {
    maxResults:opt.maxResults,
    playlistId:opt.playlistId,
    "part":"id, snippet, status"
  };
  makeRequest();

  function makeRequest(){
    if(pageToken){
      requestOptions.pageToken=pageToken;
    }
    var request=gapi.client.request({
      "mine":false,
      "path":"/youtube/v3/playlistItems",
      "params":requestOptions
    });
    request.execute(function(resp) {
      $.output(resp,pageToken);
    });
  }
  return this;
};

$.output = function(resp,pageTokenFLG){

  //ytpないページで処理しない
  if ( !$('.ytp').length ) {
    return false;
  }

	var items = resp.items;
	var
	htmlTextMainMovieHead = '',
	htmlText = '',
	publicItemsLength = 0;

	var publicItems = [];

  // ビデオが 0 件なら、処理を終了する
  if(items === undefined || !items.length ){
    $('.ytp').css({'display':'none'});
    return;
  }

  // 公開or限定公開のビデオだけ、配列に追加
  $.each(items, function(i, item){
    if(item.status.privacyStatus == 'private'){ //非公開だったらとらない
      return;
    }
    publicItems.push(item);
  });

  // 公開ビデオが 0 件だったら、処理を終了する
  if(publicItems === undefined){
    $('.ytp').css({'display':'none'});
    // $('#playbtn').css({'display':'none'});
		return;
  } else {
    $('#playbtn').css({'display':'block'});
  }

	// 公開ビデオ数格納
	publicItemsLength = publicItems.length;
	publicItems.reverse();

	htmlText += '<ul>';

	for (var i=0; i< publicItemsLength; i++){
    var publicItem = publicItems[i];

    if(i === 0){
			htmlTextMainMovieHead += '<h3>'+publicItem.snippet.title+'</h3>';
      htmlTextMainMovieHead += '<time>'+publicItem.snippet.publishedAt.slice(0,4)+'.';
      htmlTextMainMovieHead += publicItem.snippet.publishedAt.slice(5,7)+'.';
      htmlTextMainMovieHead += publicItem.snippet.publishedAt.slice(8,10)+'</time>';
			htmlText += '<li class="item"><a id="'+ publicItem.snippet.resourceId.videoId +'" class="selected';
			htmlText += '"><ul>';

      var last = moment(publicItem.snippet.publishedAt).utc();
      var now = moment().utc();
      var diff = now.diff(last, 'hours', true);
      if (diff < 72) { //3日以内
        window.sessionStorage.setItem('updateMovie',true); //登録
        addUpdateIconNav();
      } else {
        window.sessionStorage.setItem('updateMovie',false);
      }

			$('#youtube-player-container').tubeplayer({
				width: 780,
				height: 446,
				allowFullScreen: 'true',
				initialVideo: publicItem.snippet.resourceId.videoId,
				preferredQuality: 'default',
				showinfo: true,
				protocol: 'https'
			});
			$('#playbtn').css({'background-image':'url(https://i.ytimg.com/vi/'+publicItem.snippet.resourceId.videoId+'/maxresdefault.jpg)'});

		} else {
			htmlText += '<li class="item"><a id="'+ publicItem.snippet.resourceId.videoId +'" href="#"><ul>';
		}

		htmlText += '<li class="thumbnail"><img ';
		htmlText += 'src="'+publicItem.snippet.thumbnails.high.url+'" ';
		htmlText += 'alt="'+publicItem.snippet.title+'"';
		htmlText += '></li>';

		htmlText += '<li class="meta"><span class="movie-ttl">'+publicItem.snippet.title+'</span>';
		htmlText += '<time>'+publicItem.snippet.publishedAt.slice(0,4)+'.';
		htmlText += publicItem.snippet.publishedAt.slice(5,7)+'.';
		htmlText += publicItem.snippet.publishedAt.slice(8,10)+'</time></li>';
		htmlText += '</ul></a></li>';
	}

	// 動画数が4件に満たない場合、comingsoonを表示
	// if(publicItemsLength < 5){
	// 	var test = 4 - publicItemsLength;
	// 	for (var testi=1 ; testi<=test ; testi++){
  //    htmlText += '<li class="item"><a class="nomovie"><ul><li class="thumbnail"></li><li class="meta"><span class="movie-ttl">近日公開</span></li></ul></a></li>'
  //  }
  // }

  //奇数だったらcoming soon
  // if(publicItemsLength % 2 != 0){
		// htmlText += '<li class="item"><a class="nomovie"><ul><li class="thumbnail"></li><li class="meta"><span class="movie-ttl">近日公開</span></li></ul></a></li>'
  // }

  htmlText += '</ul>';

	$('#player-meta').html(htmlTextMainMovieHead);

  //２人以上いたらリストだす
  if (publicItemsLength > 1) {
    $('#play-list').html(htmlText);
  }

	// リストの高さを列毎に揃える
	$('#play-list').find('a').autoHeight({column:2});
};

$(document).on('click', '#playbtn' , function () {
	$('#playbtn').css({'display':'none'});
	$('#youtube-player-container').tubeplayer('play');
});


// show/hide判定
//////////////////////////////////
$.fn.isVisible = function() {
	return $.expr.filters.visible(this[0]);
};

// サムネイル クリックイベント
//////////////////////////////////
var
$htmlbody = $('html,body'),
$movie = $('#movie-sec'),
$playerHeader = $('#player-meta'),
$playList = $('#play-list'),
$youtubePlayerContainer = $('#youtube-player-container'),
$playBtn = $('#playbtn');

if ( $movie.length ) {

  var
  playerHeaderOffset = $movie.offset().top;

  var
  chooseMovieId = '',
  chooseMovieTime = '',
  chooseMovieTitle = '';

  var
  movieYear = '',
  movieMonth = '',
  movieDay = '';

  var
  todayDate = new Date(),
  movieDate = new Date();


  $(document).on('click', '#play-list a[href^="#"]' , function () {

    $(this).blur();

    // 初期化
    $playerHeader.removeClass('recent');
    $playList.find('a:not([href]):not(.nomovie)').attr('href','#').removeClass('selected');
    movieDate = new Date();

    $(this).removeAttr('href').addClass('selected');

    chooseMovieId = $(this).attr('id');
    chooseMovieTime = $(this).find('time').text();
    chooseMovieTitle = $(this).find('.movie-ttl').text();

    // 選択したmovieをキューにセット、日付・タイトルを置き換え
    $youtubePlayerContainer.tubeplayer('cue', chooseMovieId);
    $playerHeader.find('time').text(chooseMovieTime);
    $playerHeader.find('h3').text(chooseMovieTitle);

    $playBtn.css({'background-image':'url(http://i.ytimg.com/vi/'+chooseMovieId+'/maxresdefault.jpg)'});
    $playBtn.show();

    // プレーヤーまでスクロールしてから、動画再生
    $htmlbody.animate({scrollTop:playerHeaderOffset},1200,'easeInOutQuart',function(){
      // iphone,ipad(確認),androidの場合は、自動再生なし
      if(is.not.touchDevice()){
        $playBtn.hide();
        $youtubePlayerContainer.tubeplayer('play');
      }
    });

    return false;

  });
}



});
